import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon, Spacing, Modal, Button } from '@bluevision/components';

import { LocalStorageKey, StringBoolean } from '@/data/constant';

import styles from './styles.less';

const NEW_FEATURE_NOTIFICATION_CLICKED = LocalStorageKey.NEW_FEATURE_NOTIFICATION_CLICKED;

const NewFeatureNotification: React.FC = () => {
  const { t } = useTranslation();
  const [modalVisible, setModalVisible] = useState(false);

  /** 获取是否已点击过我知道了 */
  const getNotificationClicked = useCallback(() => {
    return localStorage.getItem(NEW_FEATURE_NOTIFICATION_CLICKED) || StringBoolean.FALSE;
  }, []);

  /** 设置已点击过我知道了 */
  const setNotificationClicked = useCallback(() => {
    localStorage.setItem(NEW_FEATURE_NOTIFICATION_CLICKED, StringBoolean.TRUE);
  }, []);

  /** 检查是否需要自动显示弹框 */
  useEffect(() => {
    const hasClicked = getNotificationClicked() === StringBoolean.TRUE;
    if (!hasClicked) {
      // 如果用户没有点击过，自动显示弹框
      setModalVisible(true);
    }
  }, [getNotificationClicked]);

  /** 处理我知道了按钮点击 */
  const handleOk = useCallback(() => {
    setNotificationClicked();
    setModalVisible(false);
  }, [setNotificationClicked]);

  /** 处理关闭弹窗（点击右上角 x 或遮罩层） */
  const handleCancel = useCallback(() => {
    setModalVisible(false);
  }, []);

  /** 处理手动点击右上角按钮 */
  const handleClick = useCallback(() => {
    setModalVisible(true);
  }, []);

  return (
    <>
      <div className={styles['new-feature-notification']} onClick={handleClick}>
        <Spacing spacing={6} align='center' justify='center'>
          <Icon name='trumpet' />
          <span>{t('new_feature_notification')}</span>
        </Spacing>
      </div>
      <Modal
        open={modalVisible}
        title={t('new_feature_notification')}
        onOk={handleOk}
        onCancel={handleCancel}
        okText={t('got_it')}
        centered
        className={styles.modal}
        footer={
          <Button type='primary' onClick={handleOk}>
            {t('got_it')}
          </Button>
        }
      >
        <div className={styles.content}>
          <div className={styles.text}>
            <div className={styles.greeting}>{t('new_feature_greeting')}</div>
            <div className={styles.desc}>{t('new_feature_title')}</div>
            <div className={styles.desc}>{t('new_feature_desc1')}</div>
            <div className={styles.linkSection}>
              {t('view_details')}
              <a
                href='https://bluefocus.feishu.cn/wiki/Cv4hwPg88iCMISkIGEzcsLdTnnq?from=from_copylink'
                target='_blank'
                rel='noopener noreferrer'
                className={styles.link}
              >
                {t('prepaid_customer_support')}
              </a>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default NewFeatureNotification;
